import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import AgentNavbar from "../../component/AgentNavbar";
import stop1 from "../../component/img/stop_1.png";
import flightgif from "../../component/img/flight.gif";
import { Link } from "react-router-dom";


const FlightResult = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

// console.log("queryParams", queryParams);

  const requestData = {
    AdultCount: queryParams.get("AdultCount"),
    ChildCount: queryParams.get("ChildCount"),
    InfantCount: queryParams.get("InfantCount"),
    JourneyType: queryParams.get("JourneyType"),
    PreferredAirlines: queryParams.get("PreferredAirlines")?.split(",") || [
      "All",
    ],
    CabinClass: queryParams.get("CabinClass"),
    Segments: [
      {
        Origin: queryParams.get("Origin"),
        Destination: queryParams.get("Destination"),
        DepartureDate: queryParams.get("DepartureDate"),
      },
    ],
    FromTerminal: queryParams.get("FromTerminal"),
    ToTerminal: queryParams.get("ToTerminal"),
  };

  // console.log("Extracted Request Data:", requestData);

  const [flightResults, setFlightResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [operators, setOperators] = useState([]);
  const [selectedOperators, setSelectedOperators] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [maxPrice, setMaxPrice] = useState(50000);


  const agentid = localStorage.getItem("agent_id") || '0';

console.log("agent id",agentid );

  const [flightMarkup, setFlightMarkup] = useState(0); // Initialize with 0

  useEffect(() => {
    if (!agentid) return console.error("No agent ID found in localStorage");
  
    const fetchMarkupDetails = async () => {
      try {
        const { data } = await axios.get(`${baseurl}getMarkupDetailsById/${agentid}`);
  
        if (data?.message === "Markup details fetched successfully") {
          const admin_flight_markup = Number(data.adminMarkup.admin_flight_markup) || 0;
          const distributor_hotel_markup = Number(data.distributorMarkup.distributor_hotel_markup) || 0;
          const agent_flight_amount = Number(data.agentMarkup.flight_markup_amount) || 0;
  
          const totalMarkup = admin_flight_markup  + agent_flight_amount;
  
          console.log("Flight Total Markup Amount:", totalMarkup);
          setFlightMarkup(totalMarkup); // Update state correctly
        } else {
          console.error("Unexpected API response", data);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    fetchMarkupDetails();
  }, [agentid]);





  useEffect(() => {
    if (!requestData.Segments[0].Origin || !requestData.Segments[0].Destination)
      return;

    axios
      .post(`${baseurl}flightsearch`, requestData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {


        console.log("response", response);
        const journeys =
          response.data.externalApiResponse.Search.FlightDataList.JourneyList;
        setFlightResults(journeys);
        setFilteredResults(journeys);

        const allOperators = new Set();
        let maxFare = 0;

        journeys.forEach((journey) => {
          journey.forEach((flight) => {
            allOperators.add(flight.FlightDetails.Details[0][0].OperatorName);
            if (flight.Price.TotalDisplayFare > maxFare) {
              maxFare = flight.Price.TotalDisplayFare;
            }
          });
        });

        setOperators([...allOperators]);
        setMaxPrice(maxFare);
        setPriceRange([0, maxFare]);

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching flight data:", error);
        setError("An error occurred while fetching flight data.");
        setLoading(false);
      });
  }, [location.search]);

  useEffect(() => {
    let filtered = flightResults;

    if (selectedOperators.length > 0) {
      filtered = filtered.map((journey) =>
        journey.filter((flight) =>
          selectedOperators.includes(
            flight.FlightDetails.Details[0][0].OperatorName
          )
        )
      );
    }

    filtered = filtered.map((journey) =>
      journey.filter(
        (flight) =>
          flight.Price.TotalDisplayFare >= priceRange[0] &&
          flight.Price.TotalDisplayFare <= priceRange[1]
      )
    );

    setFilteredResults(filtered);
  }, [selectedOperators, priceRange, flightResults]);

  const handleOperatorChange = (operator) => {
    setSelectedOperators((prev) =>
      prev.includes(operator)
        ? prev.filter((op) => op !== operator)
        : [...prev, operator]
    );
  };

  const handlePriceChange = (e) => {
    setPriceRange([0, Number(e.target.value)]);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <img
          src={flightgif}
          alt="Loading..."
          className="loading-image img-fluid gifcardimg"
        />
        <h2>Searching Best Results For You...</h2>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!filteredResults.length) {
    return <div>No flight results available.</div>;
  }

  return (
    <>
      <AgentNavbar />
      <div>
        <div className="container">
          <div className="row g-3">
            <div className="col-md-3">
              <div className="box_detail text-start">
                <h5 className="laop90">Filter Here</h5>
                <div className="px-3 mb-3">
                <div>
                  <h6>Airline</h6>
                  {operators.map((operator, index) => (
                    <div key={index} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={operator}
                        onChange={() => handleOperatorChange(operator)}
                        checked={selectedOperators.includes(operator)}
                      />
                      <label className="form-check-label" htmlFor={operator}>
                        {operator}
                      </label>
                    </div>
                  ))}
                </div>
                <div className="mt-3">
                  <h6>Price Range</h6>
                  <input
                    type="range"
                    className="form-range"
                    min="0"
                    max={maxPrice}
                    value={priceRange[1]}
                    onChange={handlePriceChange}
                  />
                  <div className="">₹{priceRange[0]} - ₹{priceRange[1]}</div>
                </div>
                </div>
                
              </div>
            </div>
            <div className="col-md-9">
              <div className="flight-results-container">
                {Object.values(filteredResults || {}).map((journey, index) => (
                  <div key={index} className="my-3">
                    {journey.map((flight, flightIndex) => (
                      <div key={flightIndex} className="card p-2 mb-3">
                        <div className="row g-0">
                          <div className="col-3 d-flex align-items-center justify-content-center">
                            <div className="text-dark mb-1 labelset2 font3">
                              {flight.FlightDetails.Details[0][0].OperatorName}{" "}
                              -{" "}
                              {flight.FlightDetails.Details[0][0].FlightNumber}
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-center justify-content-center">
                            <div className="d-flex justify-content-around align-items-center">
                              <div className="me-3">
                                <div>
                                  {new Date(
                                    flight.FlightDetails.Details[0][0].Origin.DateTime
                                  ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })}
                                </div>
                                <div>
                                  {
                                    flight.FlightDetails.Details[0][0].Origin
                                      .CityName
                                  }{" "}
                                  (
                                  {
                                    flight.FlightDetails.Details[0][0].Origin
                                      .AirportCode
                                  }
                                  )
                                </div>
                              </div>

                              <div className="me-3">
                                <div>
                                  {flight.FlightDetails.Details[0][0].Duration}{" "}
                                  mins
                                </div>
                                <div>
                                  <img src={stop1} className="img-fluid" />
                                </div>
                                <div>
                                  Stop : {flight.FlightDetails.Details[0][0].stop_over}
                                </div>
                              </div>

                              <div className="me-2">
                                <div>
                                  {new Date(
                                    flight.FlightDetails.Details[0][0].Destination.DateTime
                                  ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })}
                                </div>
                                <div>
                                  {
                                    flight.FlightDetails.Details[0][0]
                                      .Destination.CityName
                                  }{" "}
                                  (
                                  {
                                    flight.FlightDetails.Details[0][0]
                                      .Destination.AirportCode
                                  }
                                  )
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-3 d-flex align-items-center justify-content-center">
                            <div>
                              <div className="text-dark price121 font3">
                                ₹{flight.Price.TotalDisplayFare + flightMarkup} <br/>
                                {/* ₹{flight.Price.TotalDisplayFare} */}
                              </div>
                              <div className="text-dark mb-1 labelset2 font3">{flight.Attr.IsRefundable ? "Refundable" : "Non-Refundable"}</div>
                              <Link to={`/flight-detail/${flight.ResultToken}`} className="btn bookallbtn text-white">
                                Book Ticket
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightResult;
